/** Same distance and rules as the server, for the provisional chainage shown while offline. */
export function haversine(lat1: number, lon1: number, lat2: number, lon2: number) {
  const R = 6371008.8, r = (x: number) => (x * Math.PI) / 180;
  const a = Math.sin(r(lat2 - lat1) / 2) ** 2 + Math.cos(r(lat1)) * Math.cos(r(lat2)) * Math.sin(r(lon2 - lon1) / 2) ** 2;
  return 2 * R * Math.asin(Math.min(1, Math.sqrt(a)));
}

export class LocalChainage {
  private last: { lat: number; lon: number; t: number } | null = null;
  metres = 0;
  constructor(start = 0) { this.metres = start; }
  add(lat: number, lon: number, t: number) {
    if (!this.last) { this.last = { lat, lon, t }; return this.metres; }
    const d = haversine(this.last.lat, this.last.lon, lat, lon);
    const kph = (d / Math.max((t - this.last.t) / 1000, 0.001)) * 3.6;
    if (d < 2) return this.metres;
    if (d > 250 || kph > 180) return this.metres;
    this.metres += d;
    this.last = { lat, lon, t };
    return this.metres;
  }
}

export function label(m: number | null | undefined) {
  if (m === null || m === undefined) return "—";
  const v = Math.max(0, Math.round(m));
  return `${Math.floor(v / 1000)}+${String(v % 1000).padStart(3, "0")}`;
}

export function currentPosition(timeout = 20000): Promise<GeolocationPosition> {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) return reject(new Error("This browser can't read GPS."));
    navigator.geolocation.getCurrentPosition(resolve, (e) => reject(new Error(gpsError(e))), { enableHighAccuracy: true, timeout, maximumAge: 0 });
  });
}

export function gpsError(e: GeolocationPositionError) {
  if (e.code === e.PERMISSION_DENIED) return "Location permission is off. Allow location for this site in the browser settings.";
  if (e.code === e.TIMEOUT) return "No GPS fix yet. Move to open sky and try again.";
  return "GPS is unavailable right now.";
}
